// Slug → Arabic title map for the donation sub_option field.
//
// The mobile app records sub_option as a stable slug (e.g. 'zakat-oncology')
// so reports can filter by the exact donor choice even if the display
// title later gets reworded. Admin needs the human-readable label to
// render the purpose column as "زكاة مال — دعم مرضى الأورام" instead of
// "زكاة مال — zakat-oncology".
//
// KEEP THIS IN SYNC with mobile/src/data/donationCategories.ts. When a
// sub-option is added on mobile, add its slug → title here too.

const SUB_OPTION_TITLES_AR: Record<string, string> = {
  // زكاة مال
  'zakat-patients': 'علاج مرضى',
  'zakat-kafalat': 'كفالات',
  'zakat-gharemeen': 'دعم مرضى غارمين',
  'zakat-ibn-sabeel': 'ابن السبيل',
  'zakat-case': 'تبرع لحالة',
  'zakat-oncology': 'دعم مرضى الأورام',
  'zakat-sma': 'مرضى ضمور العضلات الشوكي SMA',
  'zakat-sanad': 'كارت السند',
  'zakat-dialysis': 'جلسات الغسيل الكلوي',
  // صدقة
  'sadaqa-jariya': 'صدقة جارية',
  'sadaqa-general': 'صدقة عامة',
  // قوافل غزة
  'gaza-general': 'تبرع عام لغزة',
  'gaza-women': 'مستلزمات نسائية',
  'gaza-food': 'كراتين مواد غذائية',
  'gaza-shelter': 'إيواء (خيم وكرافانات)',
  'gaza-or': 'تجهيز غرف عمليات',
  'gaza-ambulance': 'سيارات إسعاف',
  'gaza-eye-hospital': 'تجهيز مستشفى العيون بغزة',
  'gaza-blankets': 'بطاطين',
};

export function subOptionLabel(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return SUB_OPTION_TITLES_AR[slug] ?? slug;
}
